import { Text } from '@youversion/design-system-components';
import { Trans, useTranslation } from 'react-i18next';

export function MaintenanceMode({ children }: { children?: React.ReactNode }) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-2 p-4 text-center'>
      <Text component='h2' size='md' variant='headline'>
        {t('maintenance.heading')}
      </Text>
      {children}
      <Text variant='paragraph'>
        <Trans components={{ a: <a href='https://partner-support.youversion.com/' /> }} i18nKey='maintenance.body' />
      </Text>
    </div>
  );
}
